module.exports = __webpack_public_path__ + "static/media/hero_banner_1336.b9d12328.jpg";